import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadRuntimeConfig } from './runtimeConfig';
import { initConfig } from '../config/configStore';
import GlobalErrorBoundary from '../shared/observability/GlobalErrorBoundary';
import { ConfigErrorScreen } from './ConfigErrorScreen';

const renderConfigError = (error) => {
  const details = Array.isArray(error?.details) ? error.details : [];
  const message = error?.message || 'Unknown configuration error.';

  ReactDOM.createRoot(document.getElementById('root')).render(
    <ConfigErrorScreen message={message} details={details} />
  );
};

export const bootstrapApp = async () => {
  await loadRuntimeConfig();

  try {
    initConfig({
      runtimeConfig:
        typeof window !== 'undefined' && window.__APP_CONFIG__
          ? window.__APP_CONFIG__
          : {},
      env: process.env,
    });
  } catch (error) {
    console.error('Failed to initialize runtime configuration.', error);

    if (process.env.NODE_ENV !== 'production') {
      throw error;
    }

    renderConfigError(error);
    return;
  }

  const { default: App } = await import('../App');

  ReactDOM.createRoot(document.getElementById('root')).render(
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  );
};
